import React, { FC } from 'react';
import { Button, CircularProgress, useTheme } from '@mui/material';

import { IEmployeeBalanceDTO, ISystemSettingsDTO } from 'src/api/dtos';
import { useTranslate } from 'src/shared/providers';

import { AbsenceBalanceIcon } from './AbsenceBalanceIcon';
import { AbsenceBalanceSummary } from './AbsenceBalanceSummary';
import './FutureBalanceCheck.styles.scss';

interface Props {
  balance: IEmployeeBalanceDTO | undefined;
  settings: ISystemSettingsDTO | null;
  onValidate: () => void;
  onOpen: () => void;
  onCancelRequest: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const FutureBalanceCheck: FC<Props> = ({
  balance,
  loading,
  settings,
  disabled,
  onValidate,
  onOpen,
  onCancelRequest,
}) => {
  const { t } = useTranslate();
  const theme = useTheme();

  const hasEmptyBalance = !balance?.currentBalanceInSeconds && !balance?.expectedBalanceInSeconds;

  return (
    <>
      <div className="my-3">
        <div className="d-flex align-items-center">
          <label className="small d-block me-2 fw-medium">{t('absences.absenceBalanceCheck')}:</label>
          {!balance ? (
            <Button id="check-balance" disabled={disabled} color="secondary" onClick={onValidate}>
              {t('absences.checkBalance')}
            </Button>
          ) : (
            <AbsenceBalanceIcon
              balance={balance}
              shouldShowError={!!settings?.isFutureBalanceViolationBlockEnabled}
              size={28}
            />
          )}
        </div>
        {balance && !hasEmptyBalance && (
          <AbsenceBalanceSummary
            className="mt-3"
            balance={balance}
            shouldShowError={!!settings?.isFutureBalanceViolationBlockEnabled}
            shouldDisplayAsDays={!!settings?.showAccrualBalanceInDays}
            isFutureBalanceCheckEnabled={!!settings?.isFutureBalanceCheckEnabled}
            onClickDetails={onOpen}
          />
        )}

        {loading && (
          <div className={`absence-requests-checking-balance-loader ${theme.palette.mode}`}>
            <CircularProgress size={32} />
            <h4 className="my-3">{t('absences.checkingBalance')}</h4>
            <Button color="secondary" onClick={onCancelRequest}>
              {t('global.cancel')}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
